const normalizeJwtPayload = (payload) => payload.replace(/-/g, "+").replace(/_/g, "/");

export const getTokenExpiry = (token) => {
  if (!token) {
    return null;
  }

  const parts = token.split(".");
  if (parts.length < 2) {
    return null;
  }

  try {
    const decoded = JSON.parse(atob(normalizeJwtPayload(parts[1])));
    if (typeof decoded?.exp === "number") {
      return decoded.exp * 1000;
    }
  } catch (error) {
    return null;
  }

  return null;
};

export const isTokenExpired = (token) => {
  const expiry = getTokenExpiry(token);
  if (!expiry) {
    return false;
  }
  return Date.now() >= expiry;
};
